import React, {useState, useEffect} from "react";
import Navbar from "../navbar/Navbar";
import logo from "../header/Hover Systems logo.png"
import "./style.css"
import LanguageSwitcher from "../LanguageSwitcher";


const Header = () => {
    const [scrolltopdata, setscrolltotopdata] = useState('');

    useEffect(() => {
        window.addEventListener('scroll', ()=>{
            if (window.scrollY > 12) {
                setscrolltotopdata('sticky');
            } else {
                setscrolltotopdata('header')
            }
        })
    }, [])

    return ( 
        <header  className={`${scrolltopdata}`}>
            <section className="header-wrapper" id="Home" > 
                <div className="logo" >
                    <img src={logo}/>
                </div>
                <div className="languages">
                    <LanguageSwitcher/>
                </div>
            </section>
            <Navbar/>
        </header>
    );
}
 
export default Header;